import React from "react";

const formatInt = n =>
  typeof n === "number" && !Number.isNaN(n) ? n.toLocaleString() : "—";

/** Sum the first five elements, ignoring null/undefined/NaN */
const fiveYearTotal = arr =>
  arr
    .slice(0, 5)                       // years 0-4 only
    .filter(v => typeof v === "number" && !Number.isNaN(v))
    .reduce((sum, v) => sum + v, 0);

export const SchoolEnrolledTable = ({
  school,
  districtName,
  cipcodeName,
}) => {
  // quick bail-outs
  if (!school?.enrolled?.length) return null;

  return (
    <div className="bg-white py-4 px-4 rounded-b-lg">
      <h1 className="mx-4 text-lg">
        Number&nbsp;of&nbsp;Students&nbsp;Participating&nbsp;in&nbsp;
        {cipcodeName}:
      </h1>

      <div className="pt-4 pb-4 bg-indigo-50/25 rounded-lg">
        <div className="px-8 pb-8">
          <table
            id="schoolTable"
            className="w-full text-sm text-left text-gray-500 bg-white shadow-md shadow-indigo-200/40 border-x border-t border-indigo-200"
          >
            <thead className="uppercase text-slate-700 bg-indigo-50">
              <tr>
                <th colSpan={3} className="font-semibold px-6 pt-4 pb-1">
                  School&nbsp;Name
                </th>
                {[ "2021", "2022", "2023", "2024","2025", "Totals"].map(y => (
                  <th key={y} className="font-medium px-6 pt-4 pb-1">
                    {y}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {school.enrolled.map(e => {
                const yrs = e.enrollment ?? [];
                return (
                  <tr
                    key={e.schoolName}
                    className="border-b border-sky-100 hover:bg-sky-50/60 text-slate-600 last:font-semibold last:text-gray-900"
                  >
                    <td colSpan={3} className="px-6 py-2">
                      {e.schoolName === "Total" ? districtName : e.schoolName}
                    </td>

                    {/* 2020-2024 */}
                    {yrs.slice(0, 5).map((v, i) => (
                      <td key={i} className="px-6 py-2">
                        {formatInt(v)}
                      </td>
                    ))}

                    {/* ad-hoc 5-yr total */}
                    <td className="font-medium text-gray-900 px-6 py-2">
                      {formatInt(fiveYearTotal(yrs))}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};